import React from "react";
import { EFormFieldInputTypes } from "app/Components/Form/FormField.component";
import { Validation } from "app/_helpers/validation/Validation";
import {
  employeeMedicalCategoryObj,
  employeeMedicalEligibilityList,
  employeeMedicalEligibilityObj,
  initialMedicalValidation,
  initialTrainingValidation,
} from "../Employee/Constant";
import { formAFields } from "../FormA/FormA.data";
import { Dropdown } from "react-bootstrap";
import { BsThreeDotsVertical } from "react-icons/bs";
import { Link } from "react-router-dom";

export const initialContractorPersonForm = {
  aadharNumber: "",
  firstName: "",
  middleName: "",
  lastName: "",

  dob: "",
  contractorId: "",
  mobileNumber: "",
  gender: "",
  employmentStatus: "active",
  dateOfJoining: "",
  dateOfSeparation: "",
  siteType: "",
  currentWorkLocation: "",
  startDateAtMines: "",

  mineTag: "no",
  trainingEligibility: "",
  trainingDesignation: "",
  designationChangeTrainingDate: "",
  designationChangeTrainingStatus: "",

  specialMedicalExamEligibility: "",
  specialMedicalExamCategory: "",
  isPmeDate: false,
  pmeCertificateNo: "",
  pmeCertificateId: null,
  isIMEDate: false,
  imeCertificateNo: "",
  imeCertificateId: null,
};

export const contractorPersonFormLabel = {
  srNo: "Serial Number",
  aadharNumber: "Aadhar Number",
  firstName: "First Name",
  middleName: "Middle Name",
  lastName: "Last Name",
  gender: "Gender",
  dob: "Date of Birth",
  mobileNumber: "Mobile Number",

  contractorId: "Current Contractor Employer",
  employmentStatus: "Employment Tag",
  dateOfJoining: "Date of Joining",
  siteType: "Site Type",

  currentWorkLocation: "Current Work Location",
  mineTag: "Mine Tag",
  authorizedPerson: "Authorized Person",
  laborLicenseNo: "Labor License No",
  trainingDesignation: "Training Designation",
  trainingEligibility: "Training Eligibility",
  designationChangeTrainingDate: "Designation Change Training Date",
  designationChangeTrainingStatus: "Designation Change Training Status",

  specialMedicalExamEligibility: "Special Medical Exam Eligibility",
  specialMedicalExamCategory: "Special Medical Exam Category",
  designation: "Designation",
  basicTrainingCompletionDate: "Basic Training Completion Date",
  lastRefresherTrainingDate: "Last Refresher Training Date",

  dateOfSeparation: "Date of Separation",
  pmeDate: "Last PME Date",
  refresherDate: "Refresher Date",
  remark: "Remark",
  effectiveDate: "Effective Date",
  startDateAtMines: "Start Date At Mines",
  startDateAtLocation: "Start Date at Location",
  pmeCertificateNo: "PME Certificate No. (If Available)",
};

export const contractorPersonFieldRules = [
  {
    field_name: "aadharNumber",
    label: contractorPersonFormLabel.aadharNumber,
    type: "number",
    min: 12,
    max: 12,
    isRequired: true,
  },
  {
    field_name: "contractorPersonId",
    label: contractorPersonFormLabel.contractorPersonId,
    type: "text",
    isRequired: true,
  },
  {
    field_name: "firstName",
    label: contractorPersonFormLabel.firstName,
    type: "text",
    isRequired: true,
  },
  {
    field_name: "lastName",
    label: contractorPersonFormLabel.lastName,
    type: "text",
    isRequired: true,
  },

  // {
  //   field_name: "email",
  //   label: contractorPersonFormLabel.email,
  //   type: "email",
  //   isRequired: false,
  // },
  {
    field_name: "dob",
    label: contractorPersonFormLabel.dob,
    type: "text",
    isRequired: true,
  },
  {
    field_name: "mobileNumber",
    label: contractorPersonFormLabel.mobileNumber,
    type: "number",
    minLength: 10,
    maxLength: 10,
    isRequired: false,
  },
  {
    field_name: "gender",
    label: contractorPersonFormLabel.gender,
    type: "text",
    isRequired: true,
  },
  {
    field_name: "employmentStatus",
    label: contractorPersonFormLabel.employmentStatus,
    type: "text",
    isRequired: true,
  },
  {
    field_name: "startDateAtMines",
    label: contractorPersonFormLabel.startDateAtMines,
    type: "text",
    isRequired: true,
  },
  // {
  //   field_name: "dateOfJoining",
  //   label: contractorPersonFormLabel.dateOfJoining,
  //   type: "text",
  //   isRequired: false,
  // },
  // {
  //   field_name: "dateOfSeparation",
  //   label: contractorPersonFormLabel.dateOfSeparation,
  //   type: "text",
  //   // isRequired: true,
  // },
  // {
  //   field_name: "siteType",
  //   label: contractorPersonFormLabel.siteType,
  //   type: "text",
  //   isRequired: false,
  // },
  // {
  //   field_name: "currentWorkLocation",
  //   label: contractorPersonFormLabel.currentWorkLocation,
  //   type: "text",
  //   isRequired: false,
  // },
  // {
  //   field_name: "startDateAtMines",
  //   label: contractorPersonFormLabel.startDateAtMines,
  //   type: "text",
  //   // isRequired: true,
  // },
  // {
  //   field_name: "endDateAtMines",
  //   label: contractorPersonFormLabel.endDateAtMines,
  //   type: "text",
  //   // isRequired: true,
  // },
  // {
  //   field_name: "mineTag",
  //   label: contractorPersonFormLabel.mineTag,
  //   type: "text",
  //   // isRequired: true,
  // },
  // {
  //   field_name: "trainingEligibility",
  //   label: contractorPersonFormLabel.trainingEligibility,
  //   type: "text",
  //   isRequired: false,
  // },
  // {
  //   field_name: "trainingDesignation",
  //   label: contractorPersonFormLabel.trainingDesignation,
  //   type: "text",
  //   isRequired: false,
  // },
  // {
  //   field_name: "designationChangeTrainingDate",
  //   label: contractorPersonFormLabel.designationChangeTrainingDate,
  //   type: "text",
  //   isRequired: false,
  // },
  // {
  //   field_name: "designationChangeTrainingStatus",
  //   label: contractorPersonFormLabel.designationChangeTrainingStatus,
  //   type: "text",
  //   isRequired: false,
  // },
  // {
  //   field_name: "specialMedicalExamEligibility",
  //   label: contractorPersonFormLabel.specialMedicalExamEligibility,
  //   type: "text",
  //   isRequired: false,
  // },
  // {
  //   field_name: "specialMedicalExamCategory",
  //   label: contractorPersonFormLabel.specialMedicalExamCategory,
  //   type: "text",
  //   isRequired: false,
  // },
];

export const contractorPersonGenderList = [
  { name: "Male", value: "male" },
  { name: "Female", value: "female" },
  { name: "Other", value: "other" },
];

export const contractorPersonGenderObj = {
  male: "Male",
  female: "Female",
  other: "Other",
};

export const contractorPersonEmploymentStatusList = [
  { name: "Active", value: "active" },
  { name: "InActive", value: "inActive" },
];

export const contractorPersonEmploymentStatusObj = {
  active: "Active",
  inActive: "InActive",
};

export const contractorPersonMineTagList = [
  { name: "YES", value: "yes" },
  { name: "NO", value: "no" },
];

export const contractorPersonMineTagObj = { yes: "YES", no: "NO" };

export const contractorPersonTrainingEligibilityList = [
  { name: "YES", value: "yes" },
  { name: "NO", value: "no" },
];

export const contractorPersonTrainingEligibilityObj = { yes: "YES", no: "NO" };

export const contractorPersonTrainingDesignationList = [
  { name: "Designation1", value: "Designation1" },
  { name: "Designation2", value: "Designation2" },
];

export const contractorPersonTrainingDesignationObj = {
  Designation1: "Designation1",
  Designation2: "Designation2",
};

export const contractorPersonTrainingStatus = [
  { name: "Done", value: "done" },
  { name: "Not Required", value: "notRequired" },
  { name: "Overdue", value: "overdue" },
];

export const contractorPersonTrainingStatusObj = {
  done: "Done",
  notRequired: "Not Required",
  overdue: "Overdue",
};

export const contractorPersonMedicalEligibilityList = [
  { name: "YES", value: "yes" },
  { name: "NO", value: "no" },
];
export const contractorPersonMedicalEligibilityObj = { yes: "YES", no: "NO" };

export const contractorPersonMedicalCategoryList = [
  { name: "Canteen Worker", value: "canteenWorker" },
  { name: "Operator", value: "operator" },
  { name: "High Noise", value: "highNoise" },
];

export const contractorPersonMedicalCategoryObj = {
  canteenWorker: "Canteen Worker",
  operator: "Operator",
  highNoise: "High Noise",
};

export const contractorPersonValidation = (form) => {
  let errorObj = Validation(form, contractorPersonFieldRules);

  if (form.specialMedicalExamCategory) {
    if (!form.specialMedicalExamEligibility)
      errorObj["specialMedicalExamEligibility"] =
        contractorPersonFormLabel["specialMedicalExamEligibility"] + " is Required.";
  }
  if (
    form?.mobileNumber &&
    form?.mobileNumber !== "null" &&
    form?.mobileNumber !== "" &&
    form?.mobileNumber?.length !== 10
  ) {
    errorObj.mobileNumber = "Mobile should be of 10 digit";
  }
  if (form?.mobileNumber === "null") {
    errorObj.mobileNumber = "";
  }
  if (form.trainingDesignation) {
    if (!form.trainingEligibility)
      errorObj["trainingEligibility"] =
        contractorPersonFormLabel["trainingEligibility"] + " is Required.";

    // if (!form.designationChangeTrainingDate)
    //   errorObj["designationChangeTrainingDate"] =
    //     contractorPersonFormLabel["designationChangeTrainingDate"] +
    //     " is Required.";

    // if (!form.designationChangeTrainingStatus)
    //   errorObj["designationChangeTrainingStatus"] =
    //     contractorPersonFormLabel["designationChangeTrainingStatus"] +
    //     " is Required.";
  }

  if (form.siteType === 3) {
    errorObj = initialTrainingValidation(errorObj, form);
    errorObj = initialMedicalValidation(errorObj, form);
  }

  if (form.siteType) {
    if (!form.currentWorkLocation) {
      errorObj["currentWorkLocation"] =
        contractorPersonFormLabel["currentWorkLocation"] + " is Required.";
    }
  }

  if (form.employmentStatus && form.employmentStatus === "active") {
    if (!form.siteType) {
      errorObj["siteType"] = contractorPersonFormLabel["siteType"] + " is Required.";
    }

    if (!form.contractorId) {
      errorObj["contractorId"] =
        contractorPersonFormLabel["contractorId"] + " is Required.";
    }

    if (!form.dateOfJoining)
      errorObj["dateOfJoining"] =
        contractorPersonFormLabel["dateOfJoining"] + " is Required.";
  }

  return errorObj;
};

export const contractorPersonExtraToChange = (name, value, siteList, form) => {
  let extraToChange = {};

  if (name === "currentWorkLocation") {
    if (
      siteList
        .filter((d) => d.siteType === 3)
        .map((d) => d.id)
        .includes(+value)
    ) {
      extraToChange.mineTag = "yes";
    } else {
      extraToChange.mineTag = "no";
      // extraToChange.startDateAtMines = "";
    }
  }

  // if (name === "specialMedicalExamCategory") {
  //   extraToChange.specialMedicalExamEligibility = "";
  // }

  if (name === "trainingEligibility" && value === "no") {
    extraToChange.trainingDesignation = "";
    // extraToChange.designationChangeTrainingDate = "";
    // extraToChange.designationChangeTrainingStatus = "";
  }

  if (name === "specialMedicalExamEligibility" && value === "no") {
    extraToChange.specialMedicalExamCategory = "";
    // extraToChange.designationChangeTrainingDate = "";
    // extraToChange.designationChangeTrainingStatus = "";
  }

  if (name === "siteType") {
    extraToChange.currentWorkLocation = "";
    extraToChange.startDateAtMines = "";
    extraToChange.endDateAtMines = "";
    extraToChange.mineTag = "no";
  }

  if (name === "isPmeDate" && value !== form?.isPmeDate) {
    extraToChange.pmeDate = "";
    extraToChange.pmeCertificateNo = "";
    extraToChange.pmeCertificateId = null;
  }

  if (name === "isIMEDate" && value !== form?.isIMEDate) {
    extraToChange.imeDate = "";
    extraToChange.imeCertificateNo = "";
    extraToChange.imeCertificateId = null;
  }

  // if (name === "employmentStatus") {
  //   extraToChange.dateOfSeparation = "";
  // }

  if (name === "employmentStatus") {
    extraToChange.dateOfSeparation = "";

    if (value === "inActive") {
      extraToChange.contractorId = "";
      extraToChange.siteType = "";
      extraToChange.currentWorkLocation = "";
      extraToChange.mineTag = "no";
      extraToChange.dateOfJoining = "";
    }
  }
  return extraToChange;
};

export const siteHistoryFieldRules = [
  {
    field_name: "contractorId",
    label: "Contractor",
    type: "text",
    isRequired: true,
  },
  {
    field_name: "siteId",
    label: "Site",
    type: "text",
    isRequired: true,
  },
  {
    field_name: "startDate",
    label: "Start Date",
    type: "text",
    isRequired: true,
  },
  {
    field_name: "endDate",
    label: "End Date",
    type: "text",
    isRequired: true,
  },
];

export const siteHistoryValidation = (form) => {
  let errorObj = Validation(form, siteHistoryFieldRules);

  return errorObj;
};

export const contractorFormAFields = (() => {
  const obj = {};

  Object.keys(formAFields).forEach((key) => {
    obj[key] = { ...formAFields[key] };

    obj[key].fields = formAFields[key].fields.filter(
      (f) => !f.staffType || f.staffType === "contractor"
    );
  });

  return obj;
})();

export const initialContractorFormA = (() => {
  const obj = {};

  Object.keys(contractorFormAFields).forEach((key) => {
    contractorFormAFields[key].fields.forEach((field) => {
      if (field.name) obj[field.name] = "";
    });
  });

  obj.staffType = "contractor";
  obj.mineLesseName = "Odisha Mining Corporation Limited";

  return obj;
})();

export const contractorStaffFilterFields = [
  {
    name: "currentWorkLocation",
    title: "Current Location",
    inputType: EFormFieldInputTypes.searchableSelect,
  },
  {
    name: "contractorEntityName",
    title: "Current Contractor",
    inputType: EFormFieldInputTypes.text,
  },
  {
    name: "authorizedPerson",
    title: "Authorised Person",
    inputType: EFormFieldInputTypes.text,
  },
  {
    name: "srNo",
    title: "ID",
    inputType: EFormFieldInputTypes.text,
  },
  {
    name: "contractorPersonName",
    title: "Name",
    inputType: EFormFieldInputTypes.text,
  },
  {
    name: "aadharNumber",
    title: "Aadhar",
    inputType: EFormFieldInputTypes.text,
  },
  {
    name: "employmentStatus",
    title: "Emp Status",
    inputType: EFormFieldInputTypes.searchableSelect,
    options: Object.keys(contractorPersonEmploymentStatusObj).map((k) => ({
      label: contractorPersonEmploymentStatusObj[k],
      value: k,
    })),
  },
  {
    name: "gender",
    title: "Gender",
    inputType: EFormFieldInputTypes.searchableSelect,
    options: Object.keys(contractorPersonGenderObj).map((k) => ({
      label: contractorPersonGenderObj[k],
      value: k,
    })),
  },
  {
    name: "mobileNumber",
    title: "Mobile",
    inputType: EFormFieldInputTypes.text,
  },
  {
    name: "designation",
    title: "Designation",
    inputType: EFormFieldInputTypes.text,
  },
  {
    name: "formA",
    title: "Form A",
    inputType: EFormFieldInputTypes.text,
  },
  {
    name: "formAStatus",
    title: "Form A Status",
    inputType: EFormFieldInputTypes.searchableSelect,
    options: [
      { label: "Completed", value: "Completed" },
      { label: "Pending", value: "Pending" },
    ],
  },
  {
    name: "dob",
    title: "DOB",
    inputType: EFormFieldInputTypes.dateRange,
  },
  {
    name: "dateOfJoining",
    title: "DOJ",
    inputType: EFormFieldInputTypes.dateRange,
  },
  {
    name: "dateOfSeparation",
    title: "Exit Date",
    inputType: EFormFieldInputTypes.dateRange,
  },
  {
    name: "specialMedicalExamCategory",
    title: "SME Category",
    inputType: EFormFieldInputTypes.searchableSelect,
    options: Object.keys(employeeMedicalCategoryObj).map((k) => ({
      label: employeeMedicalCategoryObj[k],
      value: k,
    })),
  },
  {
    name: "smeEligibility",
    title: "SME Eligibility",
    inputType: EFormFieldInputTypes.searchableSelect,
    options: Object.keys(employeeMedicalEligibilityObj).map((k) => ({
      label: employeeMedicalEligibilityObj[k],
      value: employeeMedicalEligibilityObj[k],
    })),
  },
  // {
  //   name: "skillArea",
  //   title: "Skill Area",
  //   inputType: EFormFieldInputTypes.text,
  // },
  {
    name: "trainingEligibility",
    title: "Training",
    inputType: EFormFieldInputTypes.searchableSelect,
    options: [
      { label: "Yes", value: "yes" },
      { label: "No", value: "no" },
    ],
  },
  {
    name: "specialMedicalExamEligibility",
    title: "Medical",
    inputType: EFormFieldInputTypes.searchableSelect,
    options: [
      { label: "Yes", value: "yes" },
      { label: "No", value: "no" },
    ],
  },
];

export const searchColumn = [
  "firstName",
  "mobileNumber",
  "aadharNumber",
  "laborLicenseNo",
];

export const ContractorPersonActions = ({ id, form }) => {
  return (
    <div className="d-flex mr-3">
      {form.srNo && (
        <>
          <h5 className="font-weight-bold">Serial Number: </h5>
          <h5 className="mx-2">{form.srNo}</h5>
        </>
      )}
      <Dropdown className="col-1 dropdownBtn threeDot" style={{ marginTop: "-3px" }}>
        <Dropdown.Toggle id="dropdown-basic">
          <BsThreeDotsVertical size={18} />
        </Dropdown.Toggle>

        <Dropdown.Menu>
          {form.employmentStatus === "active" ? (
            <>
              {" "}
              <Link to={`/user-management/contractor-person/edit/` + id}>
                <Dropdown.Item href="javascript:void(0)">
                  Edit Basic Details
                </Dropdown.Item>
              </Link>
              <Link to={`/user-management/contractor-person/location/` + id}>
                <Dropdown.Item href="javascript:void(0)">Edit location</Dropdown.Item>
              </Link>
            </>
          ) : (
            ""
          )}

          {form?.siteType === 3 && (
            <>
              {form.employmentStatus === "active" ? (
                <>
                  <Link to={`/user-management/contractor-person/training/` + id}>
                    <Dropdown.Item href="javascript:void(0)">
                      Change Training Designation
                    </Dropdown.Item>
                  </Link>

                  <Link to={`/user-management/contractor-person/medical/` + id}>
                    <Dropdown.Item href="javascript:void(0)">
                      Change medical SME
                    </Dropdown.Item>
                  </Link>
                </>
              ) : (
                ""
              )}
            </>
          )}
          <Link to={`/user-management/contractor-person/employment/` + id}>
            <Dropdown.Item href="javascript:void(0)">
              Edit employment status
            </Dropdown.Item>
          </Link>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export const initialStatusForm = {
  employmentStatus: "inActive",
  dateOfSeparation: "",
  remark: "",
};
